import {Button, MantineTheme} from '@mantine/core';
import {IconDotsCircleHorizontal, IconPlayerPause, IconPlayerPlay, IconPlayerSkipForward, IconPlayerTrackNext} from '@tabler/icons-react';
import React from 'react';

interface Props {
    onClickPlay: () => void;
    mantineTheme: MantineTheme;
}

export const WavesurferCustomHoverLine = (props: Props) => {
    return (
        <div
            onClick={() => {
                // debugger;
            }}
        >
            {/* <IconPlayerTrackNext
                size={20}
                style={{
                    // color: textColor,
                    position: 'absolute',
                    left: '-10px',
                    top: '40px',
                    cursor: 'pointer',
                }}
                onClick={props.onClickPlay}
            /> */}

            <div
                style={{height: '100px', width: '10px', position: 'absolute', left: '-10px'}}
                onClick={(e) => {
                    e.stopPropagation();
                    props.onClickPlay();
                }}
            />

            <IconPlayerPause
                size={20}
                style={{
                    // color: textColor,
                    position: 'absolute',
                    left: '-10px',
                    top: '15px',
                    cursor: 'pointer',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    (window as any).togglePlayPause();
                }}
            />

            {/* <IconDotsCircleHorizontal
                style={{
                    position: 'absolute',
                    left: '-15px',
                    top: '50px',
                    cursor: 'pointer',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    props.onClickMenu({x: e.clientX, y: e.clientY})
                }}
            /> */}
        </div>
    );
}
